import { type VolunteerRole } from '@interface/IObserver';
import React from 'react';
import { Controller, type UseFormReturn } from 'react-hook-form';

import { TypeButton } from '../../../../utils/button';
import { fieldsForRole, type IFieldReadinessSchema, type READINESSINFOKEYS } from '../helper';
import { CTASection, FieldReadinessSection } from '../styled';
import FieldReadinessItem from './readiness-item';
import VolunteerRoleSelector from './volunteer-role-selector';

interface Props {
	onNext: () => void;
	onPrevious: () => void;
	hookForm: UseFormReturn<IFieldReadinessSchema>;
	role: VolunteerRole;
}

const FieldReadiness = ({ onNext, onPrevious, hookForm, role }: Props) => {
	const {
		control,
		formState: { errors },
		watch,
	} = hookForm;

	const handleReadinessInfo = (readinessArg: READINESSINFOKEYS) => (confirm: boolean) => {
		hookForm.setValue(readinessArg, confirm, { shouldValidate: true });
	};

	const readiness = watch();

	return (
		<>
			<FieldReadinessSection>
				<div className='mb-3'>
					<Controller
						name='resultType'
						control={control}
						render={({ field }) => (
							<VolunteerRoleSelector
								value={field.value}
								onChange={field.onChange}
								error={errors?.resultType?.message}
							/>
						)}
					/>
				</div>

				<div
					style={{
						display: 'grid',
						gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 320px), 1fr))',
						gap: '16px',
					}}
				>
					<FieldReadinessItem
						field='hasPartyAgentExperience'
						value={readiness.hasPartyAgentExperience}
						onToggle={handleReadinessInfo('hasPartyAgentExperience')}
					/>
					<FieldReadinessItem
						field='hasPowerBank'
						value={readiness.hasPowerBank}
						onToggle={handleReadinessInfo('hasPowerBank')}
					/>
					<FieldReadinessItem
						field='hasSmartPhoneWithInternet'
						value={readiness.hasSmartPhoneWithInternet}
						onToggle={handleReadinessInfo('hasSmartPhoneWithInternet')}
					/>
					<FieldReadinessItem
						field='isAvailableAllDay'
						value={readiness.isAvailableAllDay}
						onToggle={handleReadinessInfo('isAvailableAllDay')}
					/>
					<FieldReadinessItem
						field='isNativeSpeaker'
						value={readiness.isNativeSpeaker}
						onToggle={handleReadinessInfo('isNativeSpeaker')}
					/>
				</div>
			</FieldReadinessSection>

			<CTASection>
				<TypeButton
					title='← Previous'
					onClick={onPrevious}
					className='prevbtn'
				/>
				<TypeButton
					title='Next →'
					onClick={onNext}
					disabled={!hookForm.formState.isValid}
					className='nextbtn'
				/>
			</CTASection>
		</>
	);
};

export default FieldReadiness;
